import React, {Component} from 'react';
import {FormGroup, Select} from 'xsolla-uikit';
import { IntlProvider } from "react-intl";

const options = [
  {label: "2019", value: "2019"},
  {label: "2020", value: "2020"},
  {label: "2021", value: "2021"},
  {label: "2022", value: "2022"},
  {label: "2023", value: "2023"},
]

class SelectExample extends Component {
  constructor(props) {
    super(props)
    this.props = props;
    this.options = props.options || options;
    this.autosize = props.autosize || false;
    this.title = props.title || null;
    this.disabled = props.disabled || false;
    this.size = props.size || 'md';
    this.searchable = props.searchable || false;

    this.change = (value) => {
      this.setState({ value });
      this.props.input && this.props.input.onChange(value);
    }

    this.state = {
      value: (!this.canBeEmpty) ? this.options[0].value
        : null
    }
    // if (props.defaultValue) this.setValue(this.options[props.defaultValue].value)
  }





  render() {
    // if (!this.state.value && this.props.defaultValue) {
    //   this.setState({
    //      value: this.options[this.props.defaultValue].value
    //    })
    // }
    return (



        <FormGroup label={this.title} border={false}>
          <div style={{maxWidth: 468}}>
            <Select
              disabled={this.disabled}
              name=""
              options={this.options}
              searchable={this.searchable}
              autosize={this.autosize}
              size={this.size}
              input={{
                name: 'test',
                value: this.state.value,
                onChange: this.change
              }}
            />
          </div>
        </FormGroup>



    );
  }
}

export default SelectExample;
